import DonationProjectsMenu from './DonationProjectsMenu'

export default DonationProjectsMenu
